import { getController, postController } from '@/controllers/request';
import { MODULE, ACTION, EVENTBUS_EVENTS } from '@/utils/constants';
import { eventBus } from '@/bus';
import router from '@/router/index';
import { mixin, errorMsg } from '@/utils/mixins';

export default {
  namespaced: true,
  state: {
    currentCandidate: null,
    candidateListData: {},
    fields: {},
    messengerKey: 0,
    candidateList: [],
    vacancyCandidateStages: [],
    vacancyListData: [],
    vacancyData: [],
    resumeListData: [],
    vacancyForWindow: null,
    customPopupFields: [],
    selectedStage: null,
    deletedVacancy: null,
    visible: {
      tagForm: false
    },
    importButtonVisible: false,
    updateContactsKey: 0,
    blockedApplyVacancies: false,
    meetings: [],
    selectedMeeting: null,
    questionnaireData: {},
    metadata: {},
    changeableVacCandList: {
      changeable: false,
      list: []
    },
    changeableList: {
      changeable: false,
      list: []
    },
    loading: false,
    candidateOpening: false,
    tableTitleParams: null,
    requestSent: false
  },
  getters: {
    getSelectedStage: state => state.selectedStage
  },
  mixins: [mixin, errorMsg],
  mutations: {
    setChangeableVacCandListVisible(state) {
      state.changeableVacCandList.changeable =
        !state.changeableVacCandList.changeable;
    },
    setChangeableListVisible(state) {
      state.changeableList.changeable = !state.changeableList.changeable;
    },
    setChangeableList(state, items) {
      state.changeableList.list = items;
    },
    setChangeableVacCandList(state, items) {
      state.changeableVacCandList.list = items;
    },
    setRemoveChangeableList(state) {
      state.changeableList = {
        changeable: false,
        list: []
      };
    },
    setCandidateListData(state, value) {
      state.candidateListData = value;
    },
    setLoading(state, value) {
      state.loading = value;
    },
    setMetadata(state, metadata) {
      state.metadata = metadata;
    },
    setImportButtonVisible(state, visible) {
      state.importButtonVisible = visible;
    },
    setParam(state, { name, val, param }) {
      if (param) {
        state[name][param] = val;
      } else {
        state[name] = val;
      }
    },
    setSelectedStage(state, stage) {
      state.selectedStage = stage || null;
    },
    setFields(state, data) {
      state.fields = { ...data };
    },
    setFieldParam(state, { variable, param, value }) {
      if (state[variable]) {
        state[variable][param] = value;
      }
    },
    setVisibleElem(state, { elem, visible }) {
      state.visible[elem] = visible;
    },
    updateMessengerKey(state) {
      state.messengerKey = state.messengerKey + 1;
    },
    setVacancyData(state, data = []) {
      state.vacancyData = [...data];
    },
    setVacancyForWindow(state, { data, dialog }) {
      state.vacancyForWindow = { ...data, dialog };
      this.state.common.visible_dialog[dialog] = true;
    },
    setCustomPopupFields(state, data) {
      state.customPopupFields = data;
    },
    setDeletedVacancy(state, data = null) {
      state.deletedVacancy = data;

      if (data) {
        this.state.common.visible_dialog.relation_dialog = true;
      }
    },
    updateContacts(state) {
      state.updateContactsKey++;
    },
    blockApplyVacancies(state, data) {
      state.blockedApplyVacancies = data;
    },
    setSelectedMeeting(state, data = null) {
      state.selectedMeeting = data;
    }
  },
  actions: {
    async getMetadata({ commit, state }, id) {
      if (!state.requestSent) {
        try {
          commit('setParam', {
            name: 'requestSent',
            val: true
          });
          //если запрос не отвечает дольше, чем 300 мс, то запускается лоадер
          const loaderTimeout = setTimeout(() => {
            if (!response?.data) {
              commit('setParam', {
                name: 'loading',
                val: true
              });
              //если данных нет, ожидаем их получения каждые 500 мс
              //если они получены, отключаем роутер
              const checkData = setInterval(() => {
                if (response?.data) {
                  commit('setParam', {
                    name: 'loading',
                    val: false
                  });
                  clearInterval(checkData);
                }
              }, 500);
            }
            clearTimeout(loaderTimeout);
          }, 300);
          const response = await getController({
            params: {
              module: MODULE.CANDIDATES_MODULE,
              action: 'getCandidateView',
              record: router?.history?.current?.fullPath?.includes('candidates')
                ? router?.history?.current?.params?.id || id
                : id
            }
          });
          commit('setParam', {
            name: 'requestSent',
            val: false
          });
          commit('setMetadata', response?.data);

          if (response?.data?.bean?.id.value) {
            return true;
          } else {
            if (response?.data?.status == 'error') {
              errorMsg.methods.showNotification({
                offset: 100,
                showClose: true,
                message: response.data?.error?.error_text?.error || 'Ошибка',
                duration: 6500,
                type: 'error'
              });
            }
            return false;
          }
        } catch (e) {
          console.error(e);
        } finally {
          commit('setLoading', false);
        }
      }
    },
    async loadCandidates(
      { commit, rootState },
      { actionName, vacancyId = null, attachment = false }
    ) {
      commit('setLoading', true);
      if (!vacancyId) {
        commit(
          'selectionPopup/setBaseParams',
          {
            module: MODULE.CANDIDATES_MODULE,
            action: actionName || ACTION.LIST_VIEW,
            jsqon_return: 1,
            to_pdf: true
          },
          { root: true }
        );
      }

      let filters = {};
      let currentFilters = rootState.filters.filterConfig.filters;
      let dataSortParams = rootState.filters.filterConfig.sortable;
      let saved_search_select =
        rootState.filters.filterConfig?.savedSearchData?.selected;

      if (rootState.filters.filterConfig.sortable)
        for (let key in currentFilters) {
          if (currentFilters[key].value != null) {
            filters[key] = currentFilters[key].value;
          }
        }

      let params = {
        module: MODULE.CANDIDATES_MODULE,
        displayMode: 'spa',
        action: actionName || ACTION.LIST_VIEW,
        HRPAC_CANDIDATES2_HRPAC_CANDIDATES_offset: 0,
        saved_search_select,
        ...filters
      };

      if (attachment) {
        params.query = true;
      }

      if (rootState.filters.query) {
        params.query = true;
        commit(
          'filters/setParam',
          {
            name: 'query',
            val: false
          },
          { root: true }
        );
      }

      if (dataSortParams?.orderBy) {
        params['orderBy'] = dataSortParams.orderBy;
      }
      if (dataSortParams?.sortOrder) {
        params['sortOrder'] = dataSortParams.sortOrder;
      }

      if (vacancyId) {
        params['vacancy_id'] = vacancyId;
      }

      try {
        const request = await getController({ params });

        commit(
          'common/setTableData',
          {
            module:
              vacancyId && !attachment
                ? 'vacancy_candidates'
                : MODULE.CANDIDATES_MODULE,
            columns: request.data.data.data.data.title,
            rows: request.data.data.data.data.rows
          },
          { root: true }
        );

        commit('selectionPopup/setMetadataFields', request.data.sugarconfig, {
          root: true
        });

        commit(
          'common/setParam',
          {
            name: 'tableFields',
            val: request?.data?.sugarconfig
          },
          {
            root: true
          }
        );

        commit('selectionPopup/popupPageConfig', request.data.data.pageData, {
          root: true
        });

        commit('filters/setFiltersConfig', request.data.custom_search, {
          root: true
        });

        commit(
          'filters/setParam',
          {
            name: 'sortActive',
            val: !request.data?.custom_search?.sortable?.default || false
          },
          { root: true }
        );

        if (!vacancyId) commit('setCandidateListData', request.data);

        if (request.data.data.data.data?.title_params) {
          commit('setParam', {
            name: 'tableTitleParams',
            val: request.data.data.data.data.title_params
          });
        }

        eventBus.$emit(EVENTBUS_EVENTS.UPDATE_TABLE);
      } catch (error) {
        console.error(error);
        commit('setCandidateListData', {
          error:
            'У Вас нет доступа к данной странице. Свяжитесь с вашим системным администратором для получения соответствующих прав.'
        });
      } finally {
        commit('setLoading', false);
      }
    },
    async loadImportButtonVisible({ commit }) {
      try {
        const resp = await getController({
          params: {
            module: MODULE.CANDIDATES_MODULE,
            action: 'import_button'
          }
        });
        commit('setImportButtonVisible', resp.data.data);
      } catch (error) {
        console.error(error);
      }
    },

    async loadCustomPopupFields({ commit }, { id_vacancy, id_candidate }) {
      const request = await getController({
        params: {
          module: 'HRPAC_CUSTOM_POPUP',
          action: ACTION.GET_MODULE_FIELDS,
          id_vacancy,
          id_candidate
        }
      });

      const data = await request.data
        .filter(field => {
          switch (field.name) {
            case 'id_candidate':
              return false;
            case 'id_vacancy':
              return false;
            default:
              return true;
          }
        })
        .map(field => {
          if (!field.options) return field;
          else {
            const options = [];

            Object.keys(field.options).forEach((option, id) => {
              options.push({
                key: option,
                value: Object.values(field.options)[id]
              });
            });

            return {
              ...field,
              options
            };
          }
        });

      commit('setCustomPopupFields', data);
    },
    async saveCustomPopupFields({ state }, { id_vacancy, params }) {
      const options = new FormData();

      options.append('module', 'HRPAC_CUSTOM_POPUP');
      options.append('action', 'save');
      options.append('id_vacancy', id_vacancy);
      options.append('id_candidate', state.selectedStage.candidates_id);
      options.append('jsqon_return', 1);

      Object.keys(params).forEach((key, id) => {
        options.append(key, Object.values(params)[id]);
      });

      const request = await postController({ options });

      return await request.data;
    },
    async getFields({ state }, { fields }) {
      // экшн получения нужных полей по кандидатам
      const formData = new FormData();
      formData.append('module', MODULE.CANDIDATES_MODULE);
      formData.append('action', ACTION.GET_MODULE_FIELDS);
      formData.append('id', state.fields.id.value);
      formData.append('to_pdf', true);

      if (fields && Array.isArray(fields)) {
        fields.forEach(name => formData.append('fields[]', name));
      }

      const request = await postController({ options: formData });
      return await request.data;
    },
    async saveCorporateMailForm(ctx, email) {
      let communications = ctx.state.fields.communications.value;

      communications = communications.map(c => {
        return {
          ...c,
          sort: +c.sort + 1
        };
      });

      communications.unshift({
        htmlType: 'email',
        id: Date.now(),
        label: 'Почта',
        sort: '0',
        value: email,
        value_type: 'email'
      });

      const options = new FormData();

      options.append('module', MODULE.CANDIDATES_MODULE);
      options.append('record', ctx.state.fields.id.value);
      options.append('action', 'save');
      options.append('jsqon_return', '1');

      communications.forEach((communication, index) => {
        Object.keys(communication).forEach((c, i) => {
          options.append(
            `communications[${index}][${c}]`,
            Object.values(communication)[i]
          );
        });
      });

      try {
        await postController({
          options,
          params: {
            header: {
              'Content-Type': 'multipart/form-data'
            }
          }
        });
      } catch (e) {
        console.error(e);
      }
    },
    async getMeetings({ state, dispatch }) {
      try {
        const resp = await getController({
          params: {
            module: MODULE.CANDIDATES_MODULE,
            action: ACTION.GET_SUBPANEL_JSON_DATA,
            subpanel: 'hrpac_candidate_hrpac_event_link',
            record: state.fields.id.value,
            to_pdf: 1,
            advanced_filter: 'date_start ASC, date_entered ASC'
          }
        });
        state.meetings = resp.data.List;

        if (resp.data.error) {
          const errorText =
            resp.data.error == 'you do not have rights'
              ? 'Нет прав на просмотр списка ближайших событий'
              : resp.data.error;
          dispatch(
            'common/catchError',
            {
              err: resp.data.error,
              msg: errorText,
              action: 'get events list'
            },
            { root: true }
          );
        }
        return state.meetings;
      } catch (e) {
        console.error(e);
      }
    },
    async removeMeeting({ state, dispatch }, id) {
      const formData = new FormData();
      const params = {
        module: MODULE.HRPAC_EVENT,
        action: 'CancelEvent',
        event_id: id,
        to_pdf: 1
      };

      for (let key in params) {
        formData.set(key, params[key]);
      }

      try {
        const resp = await postController({ options: formData });
        if (resp.data?.data?.result) {
          state.meetings = state.meetings.filter(el => el.id.value !== id);
        } else {
          dispatch(
            'common/catchError',
            {
              err: resp.data.error,
              msg: resp.data.error,
              action: 'delete meeting'
            },
            { root: true }
          );
        }
      } catch (e) {
        console.error(e);
      }
    },
    async loadCandidateStages({ commit, state }, intents) {
      let response = {};
      try {
        response = await mixin.methods.sendFormRequestFromIntent(intents[0], {
          candidate_id: state.changeableVacCandList.list.map(item => item.ID)
        });
        if (response.data?.status && response.data?.status == 'error') {
          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            message: response.data.error.error_text.error,
            duration: 15000,
            type: 'error'
          });
          commit('setParam', {
            name: 'vacancyCandidateStages',
            val: []
          });
          return true;
        } else {
          commit('setParam', {
            name: 'vacancyCandidateStages',
            val: response.data
          });
        }
      } catch (err) {
        console.error(err);
      }
    },

    async fetchVacancy({ commit }, id) {
      try {
        commit('setParam', { name: 'vacancyListData', val: [] });
        //если запрос не отвечает дольше, чем 300 мс, то запускается лоадер
        const loaderTimeout = setTimeout(() => {
          if (!response?.data) {
            commit('setLoading', true);
            //если данных нет, ожидаем их получения каждые 500 мс
            //если они получены, отключаем роутер
            const checkData = setInterval(() => {
              if (response?.data) {
                commit('setLoading', false);
                clearInterval(checkData);
              }
            }, 500);
          }
          clearTimeout(loaderTimeout);
        }, 300);
        const response = await getController({
          params: {
            module: MODULE.CANDIDATES_MODULE,
            action: 'getCandidateVacancyList',
            record: id
          }
        });
        commit('setParam', {
          name: 'vacancyListData',
          val: response.data
        });

        if (response.data?.bean?.id.value) {
          return true;
        } else {
          if (response.data?.status == 'error') {
            errorMsg.methods.showNotification({
              offset: 100,
              showClose: true,
              message: response.data?.error?.error_text?.error || 'Ошибка',
              duration: 6500,
              type: 'error'
            });
          }
          return false;
        }
      } catch (e) {
        console.error(e);
      } finally {
        commit('setLoading', false);
      }
    },
    async fetchResume({ commit, state }, id) {
      if (!state.requestSent) {
        try {
          commit('setParam', {
            name: 'requestSent',
            val: true
          });
          //если запрос не отвечает дольше, чем 300 мс, то запускается лоадер
          const loaderTimeout = setTimeout(() => {
            if (!response?.data) {
              commit('setParam', {
                name: 'loading',
                val: true
              });
              //если данных нет, ожидаем их получения каждые 500 мс
              //если они получены, отключаем роутер
              const checkData = setInterval(() => {
                if (response?.data) {
                  commit('setParam', {
                    name: 'loading',
                    val: false
                  });
                  clearInterval(checkData);
                }
              }, 500);
            }
            clearTimeout(loaderTimeout);
          }, 300);
          const options = new FormData();
          options.append('module', MODULE.HRPAC_CANDIDATES_RESUME);
          options.append('action', 'getResumeDetailView');
          options.append('record', id);

          const response = await postController({ options });
          commit('setParam', {
            name: 'requestSent',
            val: false
          });
          commit('setParam', {
            name: 'resumeListData',
            val: [...state.resumeListData, response.data]
          });

          if (response.data?.bean?.id.value) {
            return true;
          } else {
            if (response.data?.status == 'error') {
              errorMsg.methods.showNotification({
                offset: 100,
                showClose: true,
                message: response.data?.error?.error_text?.error || 'Ошибка',
                duration: 6500,
                type: 'error'
              });
            }
            return false;
          }
        } catch (e) {
          console.error(e);
        } finally {
          commit('setLoading', false);
        }
      }
    },
    async fetchResumes({ dispatch, commit, state }, id) {
      if (!state.requestSent) {
        try {
          commit('setParam', {
            name: 'requestSent',
            val: true
          });
          commit('setParam', { name: 'resumeListData', val: [] });
          //если запрос не отвечает дольше, чем 300 мс, то запускается лоадер
          const loaderTimeout = setTimeout(() => {
            if (!response?.data) {
              commit('setParam', {
                name: 'loading',
                val: true
              });
              //если данных нет, ожидаем их получения каждые 500 мс
              //если они получены, отключаем роутер
              const checkData = setInterval(() => {
                if (response?.data) {
                  commit('setParam', {
                    name: 'loading',
                    val: false
                  });
                  clearInterval(checkData);
                }
              }, 500);
            }
            clearTimeout(loaderTimeout);
          }, 300);
          const options = new FormData();
          options.append('module', MODULE.HRPAC_CANDIDATES_RESUME);
          options.append('action', 'getCandidatesResumeDetailSubpanelData');
          options.append('record', id);

          const response = await postController({ options });
          commit('setParam', {
            name: 'requestSent',
            val: false
          });
          response.data?.metadata?.subpanels?.panelColumn?.forEach(panel =>
            dispatch('fetchResume', panel.id)
          );

          if (response.data?.bean?.id.value) {
            return true;
          } else {
            if (response.data?.status == 'error') {
              errorMsg.methods.showNotification({
                offset: 100,
                showClose: true,
                message: response.data?.error?.error_text?.error || 'Ошибка',
                duration: 6500,
                type: 'error'
              });
            }
            return false;
          }
        } catch (e) {
          console.error(e);
        } finally {
          commit('setLoading', false);
        }
      }
    }
  }
};
